import classNames from 'classnames';
import React from 'react';
import './index.scss';

interface EfHighlightsItemProps {
    children: React.ReactNode;
}
interface EfHighlightsProps {
    /**
     * 列表
     */
    items?: EfHighlightsItemProps[];
    /**
     * 是否启用默认的布局
     */
    layout?: 'col5row4' | 'col4row3';
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 *
 * 亮点
 */
const EfHighlights: React.FC<EfHighlightsProps> = ({ items, layout, className }) => {
    const prefixCls = `ef-highlights`;
    const classes = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
        [`${prefixCls}-layout-${layout}`]: layout,
    });
    return (
        <div className={classes}>
            {items?.map((item: any, index: number) => {
                return (
                    <div key={index} className={`${prefixCls}-item ${prefixCls}-item-${index + 1}`}>
                        {item.children}
                    </div>
                );
            })}
        </div>
    );
};

export default EfHighlights;
